import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ContactDetailsShortcutsProps {
  onClose: () => void;
}

export default function ContactDetailsShortcuts({ onClose }: ContactDetailsShortcutsProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);

  const shortcuts = [
    { key: 'Esc', description: 'Return to contacts list' },
    { key: '⌘E', description: 'Edit contact' },
    { key: '⌘M', description: 'Send email' },
    { key: '⌘F', description: 'Add follow up reminder' },
    { key: '⌘A', description: 'Add timeline entry' },
    { key: '⌘[', description: 'Previous contact' },
    { key: '⌘]', description: 'Next contact' },
    { key: '⌘O', description: 'Open contact search' },
    { key: '?', description: 'Show this help dialog' },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-dark-800 rounded-lg max-w-md w-full p-6">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Keyboard Shortcuts</h2>
          <button 
            onClick={onClose}
            className="text-gray-400 hover:text-white"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          {shortcuts.map((shortcut, index) => (
            <div key={index} className="flex justify-between items-center">
              <span className="text-gray-300">{shortcut.description}</span>
              <kbd className="px-2 py-1 bg-dark-700 rounded text-sm font-mono">{shortcut.key}</kbd>
            </div>
          ))}
        </div>

        <div className="mt-6 text-center text-gray-400 text-sm">
          Press <kbd className="px-2 py-1 bg-dark-700 rounded text-sm font-mono inline-block mx-1">?</kbd> anytime to show this dialog
        </div>
      </div>
    </div>
  );
} 